"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTargetNode = void 0;
const suggestTargetProperty = (validationMessage) => {
    const match = validationMessage.match(/[\w\d\s]+'([\w\d]+)'/);
    if (match)
        return match[1];
    else
        return null;
};
const getPathFragments = (validationResult) => {
    if (!validationResult.expression)
        return [];
    let [expressionPath] = validationResult.expression;
    expressionPath = expressionPath.replace(/\[(\d+)\]/g, ".$1");
    const pathFragments = expressionPath.split(".");
    pathFragments.shift();
    if (!pathFragments.length) {
        const pathSuggestion = suggestTargetProperty(validationResult.details.text);
        if (pathSuggestion)
            pathFragments.push(pathSuggestion);
    }
    return pathFragments;
};
const extractTargetNode = (validationResult, jsonDocument) => {
    const pathFragments = getPathFragments(validationResult);
    if (!pathFragments.length)
        return undefined;
    return pathFragments.reduce((previousNode, currentFragment) => {
        var _a, _b, _c;
        if (isNaN(+currentFragment)) {
            const fragmentNode = (_b = (_a = previousNode === null || previousNode === void 0 ? void 0 : previousNode.children) === null || _a === void 0 ? void 0 : _a.find((node) => {
                var _a;
                const [key] = (_a = node.children) !== null && _a !== void 0 ? _a : [];
                return (key === null || key === void 0 ? void 0 : key.value) === currentFragment;
            })) === null || _b === void 0 ? void 0 : _b.children;
            return fragmentNode && fragmentNode[1];
        }
        else {
            return (_c = previousNode === null || previousNode === void 0 ? void 0 : previousNode.children) === null || _c === void 0 ? void 0 : _c[+currentFragment];
        }
    }, jsonDocument.root);
};
exports.extractTargetNode = extractTargetNode;
//# sourceMappingURL=diagnostic.js.map